import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-10 lg:p-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                {appContent.title}
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-md">
                {appContent.description}
              </p>

              <div className="mt-6 space-y-3">
                {appContent.features.map((feature) => (
                  <div key={feature} className="flex items-center gap-3">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    <span className="text-sm text-foreground-700">{feature}</span>
                  </div>
                ))}
              </div>

              <div className="mt-7 flex flex-col sm:flex-row gap-3">
                <button className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                  立即访问移动版
                </button>
                <button className="px-6 py-2.5 border border-background-300/60 hover:border-primary-300 text-foreground-700 font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                  复制最新地址
                </button>
              </div>
            </div>

            <div className="flex-shrink-0 w-full lg:w-72 p-6 lg:p-0 lg:pr-10 flex justify-center">
              <div className="relative w-48 lg:w-56">
                <img
                  src={appContent.image}
                  alt="51黑料网移动端展示"
                  className="w-full h-auto rounded-2xl border border-background-200/70"
                />
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 px-4 py-1.5 bg-accent-500 text-white rounded-full text-xs font-semibold whitespace-nowrap">
                  无需下载 · 即开即用
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}